import { get } from '@Lib/request'
import { path } from './url'

const { newCarApiV3, newCarApiV2, usedCarApi } = path

export async function fetchSpecialSwitch() {
  return get<any>(`${newCarApiV3}/collection/switch`)
}

export async function fetchUsedCarNav() {
  return get<any>(`${usedCarApi}/newIndex/fastNav`)
}

export async function fetchUsedCarNavBrand() {
  return get<any>(`${usedCarApi}/newIndex/hotBrandListAndDealInfos`)
}

export async function fetchNewCarNav() {
  return get<any>(`${newCarApiV2}/movie/category`)
}

export async function fetchUserNav() {
  return get<any>(`${usedCarApi}/newIndex/loginNav`)
}

export async function fetchSearchRecommend(params?: any) {
  return get<any>(`${newCarApiV3}/search/suggest/default`, params)
}

export async function fetchSearchMentions(query: { keyword: string; pageSize?: number; ads?: number }) {
  return get<any>(`${newCarApiV3}/search/suggest/list`, query)
}

// 活動詳情
export async function fetchActiveInfo(query: any) {
  return get<any>(`${newCarApiV2}/active/info`, query)
}

// 搜索联想匹配
export async function fetchSearchSuggest(params: { keyword: string }) {
  return get<any>(`${newCarApiV3}/search/suggest/list`, params)
}
